import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getSmsEmailTemplate = createAsyncThunk('/GetSmsEmailTemplate', async () => {
  const response = await axios.get(`/GetSmsEmailTemplate`);
  return response.data;
});

export const setSmsEmailTemplate = createAsyncThunk('/SetSmsEmailTemplate', async (req) => {
  const response = await axios.post(`/SetSmsEmailTemplate`, req);
  return response.data;
});

export const getManuelSmsEmailTemplate = createAsyncThunk('/GetManuelSmsEmailTemplate', async () => {
  const response = await axios.get(`/GetManuelSmsEmailTemplate`);
  return response.data;
});

export const setManuelSmsEmailTemplate = createAsyncThunk('/SetManuelSmsEmailTemplate', async (req) => {
  const response = await axios.post(`/SetManuelSmsEmailTemplate`, req);
  return response.data;
});

export const getSmsEmailLanguages = createAsyncThunk(
  '/GetSmsEmailLanguages',
  async (tenantId) => {
    const response = await axios.get(`/GetAutomaticSmsEmailLanguageTenant/${tenantId}`);
    return response.data;
  }
);

const SmsEmailTemplateSlice = createSlice({
  name: 'SmsEmailTemplate',
  initialState: {
    loading: false,
    error: '',
    SmsEmailTemplateData: [],
    ManuelSmsEmailTemplateData: [],
    IsChecked: false,

    AutomaticSmsLanguages: [],    // <-- added language list state
    languagesLoading: false,      // <-- loading state for languages
    languagesError: '',           // <-- error state for languages
  },
  reducers: {
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    },
  },
  extraReducers: {
    [getSmsEmailTemplate.pending]: (state) => {
      state.loading = true;
    },
    [getSmsEmailTemplate.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSmsEmailTemplate.fulfilled]: (state, action) => {
      state.SmsEmailTemplateData = action.payload;
      state.loading = false;
    },

    [getManuelSmsEmailTemplate.pending]: (state) => {
      state.loading = true;
    },
    [getManuelSmsEmailTemplate.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getManuelSmsEmailTemplate.fulfilled]: (state, action) => {
      state.ManuelSmsEmailTemplateData = action.payload;
      state.loading = false;
    },

    [setSmsEmailTemplate.pending]: (state) => {
      state.loading = true;
    },
    [setSmsEmailTemplate.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setSmsEmailTemplate.fulfilled]: (state) => {
      state.loading = false;
    },

    // New reducers for language fetching:
    [getSmsEmailLanguages.pending]: (state) => {
      state.languagesLoading = true;
      state.languagesError = '';
    },
    [getSmsEmailLanguages.rejected]: (state, action) => {
      state.languagesError = action.payload;
      state.languagesLoading = false;
    },
    [getSmsEmailLanguages.fulfilled]: (state, action) => {
      state.AutomaticSmsLanguages = action.payload;
      state.languagesLoading = false;
    },
  },
});

export const SmsEmailTemplateActions = SmsEmailTemplateSlice.actions;
export default SmsEmailTemplateSlice;
